import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import IconMoon from '../../assets/images/icons/icon-moon'
import IconSun from '../../assets/images/icons/icon-sun'
import { useGlobalStore } from '../../store'
import { CustomTooltip } from '../../components'
import { ThemeButtonWrapper } from './style'

const ThemeButton = () => {
  const { setTheme, theme } = useGlobalStore()
  const handleThemeChange = () => {
    setTheme(theme === 'light' ? 'dark' : 'light')
  }

  useEffect(() => {
    return () => {
      setTheme('light')
    }
  }, [])

  const isLightTheme = theme === 'light'

  return (
    <CustomTooltip title='Switch Theme' valign='bottom'>
      <ThemeButtonWrapper onClick={handleThemeChange}>
        {isLightTheme && <IconSun />}
          <Typography className='theme-text'>{isLightTheme ? 'Light' : 'Dark'}</Typography>
        {!isLightTheme && <IconMoon />}
      </ThemeButtonWrapper>
    </CustomTooltip>
  )
}

export default ThemeButton
